import {Component} from "@angular/core";

@Component({
  selector: 'app-sotp',
  templateUrl: './sotp.component.html'
})
export class SotpComponent {}
